/* eslint-disable import/prefer-default-export */

import axios from 'axios';
import { camelizeKeys } from 'humps';

export function getKiEmailTemplates() {
  return axios
    .get('/api/v1/ki/email_templates')
    .then(res => camelizeKeys(res.data.data));
}

export function updateKiTemplate(params) {
  return axios
    .patch(`/api/v1/ki/email_templates/category/${params.category}`, params)
    .then(res => camelizeKeys(res.data));
}

export function createKiTemplate(params) {
  return axios
    .post('/api/v1/ki/email_templates/create', params)
    .then(res => camelizeKeys(res.data));
}

export function changeKiStateTemplate(category) {
  return axios
    .patch(`/api/v1/ki/email_templates/change_state/${category}`)
    .then(res => camelizeKeys(res.data));
}
